export const getCurrentUserFullName = state => state.auth.user.fullName

export const getCurrentUserEmail = state => state.auth.user.email

export const getCurrentUserId = state => state.auth.user.id
